export default __webpack_public_path__ + "static/media/hht1_song_02.7fe5b526.png";